module.exports = __webpack_public_path__ + "apple-icon-76x76.png?4fc4acafc7144efbfc0d7487167e9443";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-icon-76x76.png
// module id = 135
// module chunks = 0